import React from 'react';
import { motion } from 'framer-motion';
import { AGREEXA_APP_URL } from '../lib/links';
import { Calculator, Ruler, Battery, PaintBucket, Sun, LayoutDashboard } from 'lucide-react';
const tools = [{
  name: 'Material Calculator',
  icon: Calculator,
  desc: 'Estimate wood, screws, and hardware needed.'
}, {
  name: 'Solar & Battery Calc',
  icon: Battery,
  desc: 'Size your off-grid solar array and battery bank.'
}, {
  name: 'Room Planner',
  icon: LayoutDashboard,
  desc: '2D/3D layout tool for workshops and rooms.'
}, {
  name: 'Paint Calculator',
  icon: PaintBucket,
  desc: 'Calculate exact gallons needed for any space.'
}];
export function InteractiveTools() {
  return <section className="py-24 bg-white dark:bg-navy-800 border-y border-gray-100 dark:border-navy-700" data-id="element-167">
      <div className="max-w-7xl mx-auto px-6" data-id="element-168">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-169">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 dark:text-white mb-4" data-id="element-170">
            Pro Tools for Makers
          </h2>
          <p className="text-lg text-navy-700 dark:text-gray-400" data-id="element-171">
            Stop guessing. Use our suite of interactive calculators and planners
            to get your project right the first time.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-172">
          {tools.map((tool, index) => <motion.div key={tool.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} onClick={() => {
          window.location.href = AGREEXA_APP_URL;
        }} className="p-6 rounded-2xl border border-gray-200 dark:border-navy-700 hover:border-orange-500 dark:hover:border-orange-500 bg-soft dark:bg-navy-900/50 group cursor-pointer transition-all duration-300" data-id="element-173">
              <div className="w-12 h-12 rounded-xl bg-white dark:bg-navy-800 shadow-sm flex items-center justify-center text-navy-900 dark:text-white mb-6 group-hover:scale-110 group-hover:text-orange-500 transition-all duration-300" data-id="element-174">
                <tool.icon size={24} data-id="element-175" />
              </div>
              <h3 className="text-lg font-bold text-navy-900 dark:text-white mb-2 group-hover:text-orange-500 transition-colors" data-id="element-176">
                {tool.name}
              </h3>
              <p className="text-sm text-navy-700 dark:text-gray-400" data-id="element-177">
                {tool.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}